<template>
  <div
    id="secondaryButton"
    class="focus:shadow-outline transition-200 transition-ease-in-out font-heading relative z-10 inline-block select-none rounded-lg border text-center text-xs font-medium uppercase leading-tight tracking-wide transition-all focus:outline-none"
    :class="getClasses()"
    @click="emitClick"
  >
    <div
      class="flex h-full w-full justify-evenly text-center"
      :class="loading ? 'opacity-0' : ''"
      style="padding-top: 2px; margin-botton: -2px; margin-top: -2px"
    >
      <span class="flex">
        {{ text }}
      </span>
      <div
        ref="button"
        class="hidden"
      >
        <slot name="svg" />
      </div>
    </div>
    <div
      v-if="loading"
      class="absolute left-0 top-0 flex h-full w-full items-center justify-center"
    >
      <LoadingSpinner
        :white="true"
        class="-mt-2"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    textSize: {
      type: String,
      default: 'text-xs ',
    },
    padding: {
      type: String,
      default: 'py-3 px-4 ',
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.hackClassesIn();
  },

  methods: {
    emitClick(evt) {
      if (!this.loading && !this.disabled) {
        // Pass through native event so parent modifiers like .stop work on @click
        this.$emit('click', evt);
      }
    },

    hackClassesIn() {
      if (this.$refs.button.children.length > 0) {
        this.$refs.button.classList.remove('hidden');
        this.$refs.button.classList.add('flex');
        this.$refs.button.classList.add('items-center');
        this.$refs.button.classList.add('h-full');
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.$refs.button.children) {
          item.classList.add('h-6');
          item.classList.add('w-6');
          item.classList.add('inline-block');
          item.classList.add('fill-secondary-500');
        }
      }
    },

    getClasses() {
      let classes = `${this.textSize} ${this.padding} `;

      if (this.fullWidth) {
        classes += 'w-full ';
      }

      if (this.loading) {
        classes += 'cursor-wait ';
      }
      if (this.disabled) {
        classes += 'bg-gray-200 text-gray-600 ';
      } else {
        classes
          += 'bg-white hover:bg-gray-50 text-secondary-500 hover:text-secondary-300 cursor-pointer';
      }

      return classes;
    },
  },
};
</script>
